import * as React from 'react';
import { ProductCatalogList } from '../components/Menu';
import DashboardComponentList from '../pages/home/dashboard/DashboardComponent';

export const menuConfigItems = {
  profile: {
    root: true,
    title: 'SUBMENU.PROFILE',
    translate: 'SUBMENU.PROFILE',
    page: 'settings/profile',
    activePages: ['settings/profile'],
  },

  logout: {
    root: true,
    title: 'MENU.LOGOUT',
    translate: 'MENU.LOGOUT',
    page: 'logout',
    // icon: 'flaticon-logout',
  },

  productDashboard: {
    title: 'MENU.DASHBOARD',
    translate: 'MENU.DASHBOARD',
    bullet: 'dot',
    root: true,
    page: 'products/dashboard',
    // inActivePages: ['dashboard'],
  },

  products: {
    title: 'MENU.PRODUCTS',
    translate: 'MENU.PRODUCTS',
    bullet: 'dot',
    root: true,
    inActivePages: ['products/types'],
    // page: 'navigation/products',
    page: 'products/catalog',
    dynamic: () => <DashboardComponentList />,
    submenu: [
      // {
      //   title: 'MENU.DASHBOARD',
      //   translate: 'MENU.DASHBOARD',
      //   bullet: 'dot',
      //   page: 'products/dashboard',
      //   // inActivePages: ['dashboard'],
      // },
      {
        title: 'PRODUCT.ALL.PRODUCTS',
        translate: 'PRODUCT.ALL.PRODUCTS',
        page: 'products/catalog',
        activePages: ['products/catalog'],
        dynamic: () => <ProductCatalogList />,
      },
      {
        title: 'PRODUCT.ADD.MULTIPLY.PRODUCTS',
        translate: 'PRODUCT.ADD.MULTIPLY.PRODUCTS',
        page: 'products/add_multiply',
      },
      {
        title: 'PRODUCT.ADD.PRICE.EDITING.PRODUCTS',
        translate: 'PRODUCT.ADD.PRICE.EDITING.PRODUCTS',
        page: 'products/edit_pricing',
      },
      //      {
      //        title: 'PRODUCT.ALL.NEW_PRODUCTS',
      //        page: 'products/new',
      //        translate: 'PRODUCT.ALL.NEW_PRODUCTS',
      //      },
      //      {
      //        title: 'MENU.COMPANY.PRODUCTS',
      //        page: 'products/list',
      //        translate: 'MENU.COMPANY.PRODUCTS',
      //        activePages: ['products/edit', 'products/create'],
      //      },
      {
        title: 'CATEGORIES.TABLE.TOOLTIP.FAVORITES_PRODUCTS',
        page: 'products/favorites',
        translate: 'CATEGORIES.TABLE.TOOLTIP.FAVORITES_PRODUCTS',
      },
      {
        title: 'MENU.CATALOG.CATEGORIES.LIST',
        page: 'categories/list',
        translate: 'MENU.CATALOG.CATEGORIES.LIST',
        activePages: ['categories/edit', 'categories/new'],
      },
      {
        title: 'MENU.CATALOG.CATEGORIES.TREE',
        page: 'categories/tree',
        translate: 'MENU.CATALOG.CATEGORIES.TREE',
      },
    ],
  },

  vendorProducts: {
    title: 'MENU.PRODUCTS',
    translate: 'MENU.PRODUCTS',
    bullet: 'dot',
    root: true,
    activePages: ['categories', 'viewproduct'],
    page: 'products/company',
    submenu: [
      // {
      //   title: 'MENU.CATALOG.PRODUCTS',
      //   translate: 'MENU.CATALOG.PRODUCTS',
      //   page: 'products/catalog',
      //   activePages: ['products/catalog'],
      //   dynamic: () => <ProductCatalogList />,
      // },
      {
        title: 'MENU.COMPANY.PRODUCTS',
        page: 'products/company',
        translate: 'MENU.COMPANY.PRODUCTS',
        activePages: ['products/edit', 'products/create'],
      },
      // {
      //   title: 'CATEGORIES.TABLE.TOOLTIP.FAVORITES_PRODUCTS',
      //   page: 'products/favorites',
      //   translate: 'CATEGORIES.TABLE.TOOLTIP.FAVORITES_PRODUCTS',
      // },
      {
        title: 'MENU.CATALOG.CATEGORIES.LIST',
        page: 'categories/list',
        translate: 'MENU.CATALOG.CATEGORIES.LIST',
        activePages: ['categories/edit', 'categories/new'],
      },
      {
        title: 'MENU.CATALOG.CATEGORIES.TREE',
        page: 'categories/tree',
        translate: 'MENU.CATALOG.CATEGORIES.TREE',
      },
    ],
  },

  vendorCompany: {
    root: true,
    title: 'MENU.VENDOR.COMPANY',
    translate: 'MENU.VENDOR.COMPANY',
    bullet: 'dot',
    activePages: ['companies', 'stores'],
    page: 'companies/list',
    submenu: [
      {
        translate: 'SUBMENU.COMPANY_SETTINGS',
        page: 'companies/list',
        title: 'SUBMENU.COMPANY_SETTINGS',
        activePages: ['companies/edit', 'companies/new'],
      },
      {
        translate: 'MENU.CATALOG.STORES',
        title: 'MENU.CATALOG.STORES',
        page: 'stores/list',
        activePages: ['stores/edit', 'stores/create'],
      },
    ],
  },

  tenders: {
    root: true,
    title: 'MENU.TENDERS',
    translate: 'MENU.TENDERS',
    bullet: 'dot',
    activePages: ['tenders/'],
    submenu: [
      {
        translate: 'SUBMENU.ALLTENDERS',
        title: 'SUBMENU.ALLTENDERS',
        page: 'tenders/list/full',
      },
    ],
  },
  ordersBuyer: {
    root: true,
    title: 'MENU.ORDERS',
    translate: 'MENU.ORDERS',
    bullet: 'dot',
    activePages: ['orders/'],
    page: 'orders/list/full',
    // submenu: [
    //   {
    //     translate: 'SUBMENU.ALLORDERS',
    //     title: 'SUBMENU.ALLORDERS',
    //     page: 'orders/list/full',
    //   },

    //   {
    //     translate: 'SUBMENU.HISTORY',
    //     title: 'SUBMENU.HISTORY',
    //     page: 'orders/list/history',
    //   },
    // ],
  },

  allTenders: {
    root: true,
    title: 'MENU.TENDERS',
    translate: 'MENU.TENDERS',
    bullet: 'dot',
    page: 'tenders/list/full',
    activePages: ['tenders', 'tenders/list/full'],
    submenu: [
      {
        translate: 'SUBMENU.ALLTENDERS',
        title: 'SUBMENU.ALLTENDERS',
        page: 'tenders/list/full',
      },
    ],
  },

  buyersTenders: {
    root: true,
    title: 'MENU.TENDERS',
    translate: 'MENU.TENDERS',
    bullet: 'dot',
    page: 'tenders/list/full',
    activePages: ['tenders'],
    // submenu: [
    //   {
    //     translate: 'SUBMENU.ALLTENDERS',
    //     title: 'SUBMENU.ALLTENDERS',
    //     page: 'tenders/list/full',
    //   },
    //   {
    //     translate: 'SUBMENU.MYTENDERS',
    //     title: 'SUBMENU.MYTENDERS',
    //     page: 'tenders/list/my',
    //   },
    // ],
  },

  vendorsTenders: {
    root: true,
    title: 'MENU.TENDERS',
    translate: 'MENU.TENDERS',
    bullet: 'dot',
    page: 'tenders/list/full',
    activePages: ['tenders'],
    submenu: [
      {
        translate: 'SUBMENU.TENDER.VENDOR',
        title: 'SUBMENU.TENDER.VENDOR',
        page: 'tenders/list/full',
      },
    ],
  },

  addTender: {
    root: true,
    title: 'TENDER.BUTTON.ADD',
    translate: 'TENDER.BUTTON.ADD',
    bullet: 'dot',
    page: 'tenders/create',
    submenu: [
      {
        translate: 'MENU.MY_COMPANY',
        title: 'MENU.MY_COMPANY',
        page: 'companies/list',
      },
    ],
  },

  orders: {
    root: true,
    title: 'MENU.ORDERS',
    translate: 'MENU.ORDERS',
    bullet: 'dot',
    page: 'orders/list/full',
    submenu: [
      {
        translate: 'SUBMENU.ALLORDERS',
        title: 'SUBMENU.ALLORDERS',
        page: 'orders/list/full',
      },
      // {
      //   title: 'MENU.DELIVERY.DOCUMENTS',
      //   translate: 'MENU.DELIVERY.DOCUMENTS',
      //   page: 'delivery/list/full',
      // },
      {
        translate: 'SUBMENU.ABANDONEDCHECKOUTS',
        title: 'SUBMENU.ABANDONEDCHECKOUTS',
        page: 'orders/list/abandoned',
      },
    ],
  },

  buyersDocuments: {
    root: true,
    title: 'MENU.DELIVERY.DOCUMENTS',
    translate: 'MENU.DELIVERY.DOCUMENTS',
    bullet: 'dot',
    page: 'delivery/list/full',
  },

  buyersDocumentsHistory: {
    root: true,
    title: 'MENU.DELIVERY.DOCUMENTS.HISTORY',
    translate: 'MENU.DELIVERY.DOCUMENTS.HISTORY',
    bullet: 'dot',
    page: 'delivery/list/history',
  },

  buyersOrders: {
    root: true,
    title: 'MENU.MY_ORDERS',
    translate: 'MENU.MY_ORDERS',
    bullet: 'dot',
    page: 'orders/list/full',
    activePages: ['orders'],
  },

  companies: {
    root: true,
    title: 'MENU.COMPANIES',
    translate: 'MENU.COMPANIES',
    bullet: 'dot',
    activePages: ['companies', 'stores', 'viewcompany'],
    page: 'companies/list',
    submenu: [
      {
        translate: 'MENU.CATALOG.STORES',
        title: 'MENU.CATALOG.STORES',
        page: 'stores/list',
      },
    ],
  },

  usersManager: {
    root: true,
    title: 'MENU.USERS',
    translate: 'MENU.USERS',
    bullet: 'dot',
    activePages: ['users'],
    page: 'users/vendors',
    submenu: [
      {
        translate: 'SUBMENU.VENDORS',
        title: 'SUBMENU.VENDORS',
        page: 'users/vendors',
      },

      {
        translate: 'SUBMENU.COMPANIES',
        title: 'SUBMENU.COMPANIES',
        page: 'companies/list',
      },
    ],
  },

  users: {
    root: true,
    title: 'MENU.USERS',
    translate: 'MENU.USERS',
    bullet: 'dot',
    activePages: ['users'],
    page: 'users/buyers',
    submenu: [
      {
        translate: 'SUBMENU.CUSTOMERS',
        title: 'SUBMENU.CUSTOMERS',
        page: 'users/buyers',
        activePages: ['users/buyers'],
      },
      {
        translate: 'SUBMENU.VENDORS',
        title: 'SUBMENU.VENDORS',
        page: 'users/vendors',
      },
      {
        translate: 'SUBMENU.TEAM',
        title: 'SUBMENU.TEAM',
        page: 'users/managers',
      },
      {
        translate: 'SUBMENU.COMPANIES',
        title: 'SUBMENU.COMPANIES',
        page: 'companies/list',
      },
    ],
  },

  vendorUsers: {
    root: true,
    title: 'MENU.TEAM',
    translate: 'MENU.TEAM',
    bullet: 'dot',
    page: 'users/managers',
    activePages: ['users'],
  },

  settings: {
    root: true,
    title: 'MENU.SETTINGS',
    bullet: 'dot',
    translate: 'MENU.SETTINGS',
    activePages: ['products/types'],
    page: 'products/types/list',
    submenu: [
      {
        title: 'MENU.PRODUCTS.TYPES',
        translate: 'MENU.PRODUCTS.TYPES',
        page: 'products/types/list',
        activePages: ['products/types/create'],
      },
      {
        title: 'MENU.PRODUCTS.BANNERS',
        translate: 'MENU.PRODUCTS.BANNERS',
        page: 'banners/list',
        activePages: ['banners', 'banners/create', 'banners/edit'],
      },
      {
        title: 'GROUPS',
        translate: 'GROUPS',
        page: 'groups/list',
        activePages: ['groups/list'],
      },
      {
        title: 'CART.DELIVERY.COST',
        translate: 'CART.DELIVERY.COST',
        page: 'delivery/prices',
        activePages: ['delivery/prices'],
      },
      //      {
      //        title: 'COLLECTIONS',
      //        translate: 'COLLECTIONS',
      //        page: 'collections/list',
      //        activePages: ['collections/list'],
      //      },
      //      {
      //        title: 'MENU.PRODUCTS.PROMOCODES',
      //        translate: 'MENU.PRODUCTS.PROMOCODES',
      //        page: 'promocodes/list',
      //        activePages: ['promocodes', 'promocodes/edit', 'promocodes/new'],
      //      },
      //      {
      //        title: 'MENU.PRODUCTS.REFFERALS',
      //        translate: 'MENU.PRODUCTS.REFFERALS',
      //        page: 'refferals/list',
      //        activePages: ['refferals', 'refferals/edit', 'refferals/new'],
      //      },
      //      {
      //        title: 'MENU.PRODUCTS.TRANSACTIONS',
      //        translate: 'MENU.PRODUCTS.TRANSACTIONS',
      //        page: 'transactions/list',
      //        activePages: ['transactions'],
      //      },
    ],
  },

  settingManager: {
    root: true,
    title: 'MENU.SETTINGS',
    bullet: 'dot',
    translate: 'MENU.SETTINGS',
    activePages: ['products/types'],
    page: 'products/types/list',
    submenu: [
      {
        title: 'MENU.PRODUCTS.BANNERS',
        translate: 'MENU.PRODUCTS.BANNERS',
        page: 'banners/list',
        activePages: ['banners', 'banners/create', 'banners/edit'],
      },
    ],
  },

  legal: {
    root: true,
    title: 'SUBMENU.LEGAL',
    translate: 'SUBMENU.LEGAL',
    bullet: 'dot',
    activePages: ['documents'],
    page: 'documents/legacy',
    submenu: [
      {
        title: 'SUBMENU.LEGAL_TERMS',
        translate: 'SUBMENU.LEGAL_TERMS',
        page: 'documents/legacy',
      },
      {
        title: 'SUBMENU.LEGAL_PRIVACY',
        translate: 'SUBMENU.LEGAL_PRIVACY',
        page: 'documents/privacy',
      },
      {
        title: 'SUBMENU.LEGAL_SHIPPING',
        translate: 'SUBMENU.LEGAL_SHIPPING',
        page: 'documents/shipping',
      },
      {
        title: 'SUBMENU.LEGAL_REFUND',
        translate: 'SUBMENU.LEGAL_REFUND',
        page: 'documents/refund',
      },
    ],
  },

  catalog: {
    root: true,
    title: 'MENU.CATALOG.PRODUCTS',
    translate: 'MENU.CATALOG.PRODUCTS',
    bullet: 'dot',
    // icon: 'flaticon-book',
    page: 'products/catalog',
    dynamic: () => <ProductCatalogList />,
    activePages: ['products', 'viewproduct'],
    submenu: [
      {
        title: 'MENU.CATALOG.PRODUCTS',
        translate: 'MENU.CATALOG.PRODUCTS',
        page: 'products/catalog',
        activePages: ['products/catalog'],
        dynamic: () => <ProductCatalogList />,
      },
      {
        title: 'COLLECTIONS',
        translate: 'COLLECTIONS',
        page: 'collections/list',
        activePages: ['collections/list'],
      },
    ],
  },

  catalogForUser: {
    root: true,
    title: 'MENU.CATALOG.PRODUCTS',
    translate: 'MENU.CATALOG.PRODUCTS',
    bullet: 'dot',
    // icon: 'flaticon-book',
    page: 'products/catalog',
    dynamic: () => <ProductCatalogList />,
    activePages: ['products', 'viewproduct'],
    // submenu: [
    //   {
    //     title: 'MENU.CATALOG.PRODUCTS',
    //     translate: 'MENU.CATALOG.PRODUCTS',
    //     page: 'products/catalog',
    //     activePages: ['products/catalog'],
    //     dynamic: () => <ProductCatalogList />,
    //   },
    //   {
    //     title: 'CATEGORIES.TABLE.TOOLTIP.FAVORITES_PRODUCTS',
    //     page: 'products/favorites',
    //     translate: 'CATEGORIES.TABLE.TOOLTIP.FAVORITES_PRODUCTS',
    //   },
    //   {
    //     title: 'COLLECTIONS',
    //     translate: 'COLLECTIONS',
    //     page: 'collections/list',
    //     activePages: ['collections/list'],
    //   },
    // ],
  },

  login: {
    root: true,
    title: 'MENU.LOGIN',
    translate: 'MENU.LOGIN',
    bullet: 'dot',
    // icon: 'flaticon-login',
    page: 'auth',
  },

  blog: {
    root: true,
    title: 'SUBMENU.BLOG',
    translate: 'SUBMENU.BLOG',
    bullet: 'dot',
    activePages: ['blog'],
    page: 'blog/my',
    submenu: [
      {
        title: 'SUBMENU.BLOG.ALL',
        page: 'blog/all',
        translate: 'SUBMENU.BLOG.ALL',
        activePages: ['blog/edit', 'blog/create', 'blog/view'],
      },
      {
        title: 'SUBMENU.BLOG.MY',
        page: 'blog/my',
        translate: 'SUBMENU.BLOG.MY',
      },
    ],
  },

  guestBlog: {
    root: true,
    title: 'SUBMENU.BLOG.ALL',
    translate: 'SUBMENU.BLOG.ALL',
    bullet: 'dot',
    page: 'blog/all',
    activePages: ['blog'],
  },

  tariffs: {
    root: true,
    title: 'SUBMENU.TARIFFS',
    translate: 'SUBMENU.TARIFFS',
    bullet: 'dot',
    activePages: ['tariffs'],
    page: 'tariffs/list/vendors',
    submenu: [
      {
        title: 'SUBMENU.TARIFFS.BUYERS',
        page: 'tariffs/list/buyers',
        translate: 'SUBMENU.TARIFFS.BUYERS',
      },
      {
        title: 'SUBMENU.TARIFFS.VENDORS',
        page: 'tariffs/list/vendors',
        translate: 'SUBMENU.TARIFFS.VENDORS',
      },
    ],
  },

  buyersTariffs: {
    root: true,
    title: 'SUBMENU.TARIFFS',
    translate: 'SUBMENU.TARIFFS',
    bullet: 'dot',
    page: 'tariffs/list/buyers',
    activePages: ['tariffs'],
  },

  vendorsTariffs: {
    root: true,
    title: 'SUBMENU.TARIFFS',
    translate: 'SUBMENU.TARIFFS',
    bullet: 'dot',
    page: 'tariffs/list/vendors',
    activePages: ['tariffs'],
  },

  chats: {
    root: true,
    title: 'SUBMENU.CHATS',
    translate: 'SUBMENU.CHATS',
    bullet: 'dot',
    page: 'chats',
    activePages: ['chats'],
  },
  dashboard: {
    root: true,
    title: 'MENU.DASHBOARD',
    translate: 'MENU.DASHBOARD',
    bullet: 'dot',
    page: 'dashboard/list',
    // inActivePages: ['dashboard'],
    activePages: ['dashboard/list'],
  },
};
